fragment TeamFragment on Group {
  id
  kind
  isHidden
  name
  type
  parentIds
  hierarchyIds
  attributes {
    id
    attributeType
    subtype
    label
    value
  }
}



query getValueGraph($input: ValueGraphInput!) {
  valueGraph(input: $input) {
    objectives {
      id
      name
      objectiveType
      objectiveTypeDisplayName
      dataSource {
        type
      }
      attributes {
        id
        attributeType
        subtype
        label
        value
      }
      parentIds
      childObjectiveIds
      teams {
        ...TeamFragment
      }
    }
  }
}
